import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useClearGiftMutation = (clockId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["clearGift", clockId],
    mutationFn: () => adminApiClient.clearGift(clockId),
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ["deviceGifts", clockId] }),
  });
};

export default useClearGiftMutation;
